module.exports = __webpack_public_path__ + "img/outputdata-image2.429a89bb.png";